import { ContainerType } from './container.types';

export type ContainerRouteSegment = 'project' | 'db';
export type ContainerWorkspaceSegment = 'motoric' | 'visual' | 'imageDb';

const CONTAINER_ROUTE_SEGMENT_BY_TYPE: Record<
    ContainerType,
    ContainerRouteSegment
> = {
    [ContainerType.PROJECT_VISUAL]: 'project',
    [ContainerType.PROJECT_MOTORIC]: 'project',
    [ContainerType.IMAGE_DB]: 'db',
};

const CONTAINER_WORKSPACE_SEGMENT_BY_TYPE: Record<
    ContainerType,
    ContainerWorkspaceSegment
> = {
    [ContainerType.PROJECT_VISUAL]: 'visual',
    [ContainerType.PROJECT_MOTORIC]: 'motoric',
    [ContainerType.IMAGE_DB]: 'imageDb',
};

export const getContainerRouteSegment = (
    containerType: ContainerType
): ContainerRouteSegment => CONTAINER_ROUTE_SEGMENT_BY_TYPE[containerType];

export const getContainerWorkspaceSegment = (
    containerType: ContainerType
): ContainerWorkspaceSegment | undefined =>
    CONTAINER_WORKSPACE_SEGMENT_BY_TYPE[containerType];
